<div class="w-full bg-white p-5">
    <div class="mx-auto flex max-w-6xl md:gap-7">
        <div class="relative flex w-full flex-col gap-4">
            <div class="flex flex-col gap-1">
                <ng-container *ngIf="actif">
                    <div
                        class="flex items-center justify-between sm:justify-normal sm:gap-12"
                    >
                        <h1
                            class="text-3xl font-semibold uppercase text-[#3F3F3F]"
                        >
                            {{ actif?.referentiel?.stockName }}
                        </h1>
                        <button
                            *ngIf="showAddButton()"
                            (click)="addToWatchlist()"
                            class="rounded-full bg-[#0045E6] px-2 py-1 text-xs font-semibold text-white"
                        >
                            + Ajouter à ma Watchlist
                        </button>
                        <span
                            *ngIf="showFollowButton()"
                            class="rounded-full bg-[#0E9687] px-2 py-1 text-xs font-semibold text-white"
                            >Valeur suivie</span
                        >
                    </div>
                    <div class="border-t border-black"></div>
                    <div class="flex items-center gap-4">
                        <span class="text-3xl font-bold"
                            >{{ actif?.last | number: '.2-2' }}
                        </span>
                        <div
                            class="flex items-center text-lg font-semibold"
                            [ngClass]="{
                                'text-[#0E9687]': actif?.change >= 0,
                                'text-[#E70013]': actif?.change < 0,
                            }"
                        >
                            <mat-icon
                                class="icon-size-5"
                                [svgIcon]="
                                    actif?.change >= 0
                                        ? 'heroicons_solid:arrow-small-up'
                                        : 'heroicons_solid:arrow-small-down'
                                "
                            />
                            <span
                                >{{
                                    actif?.change | abs | number: '.2-2'
                                }}%</span
                            >
                        </div>
                    </div>
                </ng-container>
            </div>

            <div class="flex flex-col gap-1">
                <div #chartContainer class="relative h-80 w-full">
                    <div
                        #tooltipContainer
                        class="absolute z-10 text-nowrap rounded border border-[#ccc] bg-white p-2 text-sm"
                        [ngClass]="showTooltip ? 'block' : 'hidden'"
                    >
                        <div class="text-center">
                            {{ tooltipValue | number: '.2-2' }}
                        </div>
                        <div>{{ tooltipDate | date: 'dd MMM YYYY, H:mm' }}</div>
                    </div>
                </div>
                <span class="text-xs text-gray-600"
                    >Propulsé par
                    <a
                        class="hover:underline"
                        href="https://www.tradingview.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        >Tradingview</a
                    ></span
                >
            </div>

            <div
                class="my-6 flex flex-col items-center gap-6 sm:flex-row sm:items-start sm:justify-center sm:gap-20"
            >
                <div class="flex w-full max-w-72 flex-col gap-1">
                    <span class="font-bold uppercase text-[#0045E6]"
                        >séance du jour</span
                    >
                    <table>
                        <thead>
                            <tr>
                                <th class="px-3 py-1 text-start">Désignation</th>
                                <th class="px-3 py-1 text-end">Valeur</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="bg-[#E5E4E4]">
                                <td class="px-3 py-1">Plus Haut</td>
                                <td class="px-3 py-1 text-end">
                                    {{ actif?.high | number: '.2-2' }}
                                </td>
                            </tr>
                            <tr class="bg-[#F3F3F3]">
                                <td class="px-3 py-1">Plus Bas</td>
                                <td class="px-3 py-1 text-end">
                                    {{ actif?.low | number: '.2-2' }}
                                </td>
                            </tr>
                            <tr class="bg-[#E5E4E4]">
                                <td class="px-3 py-1">Clôture veille</td>
                                <td class="px-3 py-1 text-end">
                                    {{ actif?.close | number: '.2-2' }}
                                </td>
                            </tr>
                            <tr class="bg-[#F3F3F3]">
                                <td class="px-3 py-1">Titres échangés</td>
                                <td class="px-3 py-1 text-end">
                                    {{ actif?.caps | number: '.0-0' }}
                                </td>
                            </tr>
                            <tr class="bg-[#E5E4E4]">
                                <td class="px-3 py-1">Volume (DT)</td>
                                <td class="px-3 py-1 text-end">
                                    {{ actif?.volume | number: '.0-0' }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div class="flex w-full max-w-72 flex-col gap-1">
                    <span class="font-bold uppercase text-[#0045E6]"
                        >dividende par action</span
                    >
                    <table>
                        <thead>
                            <tr>
                                <th class="px-3 py-1 text-start">Année de distribution</th>
                                <th class="px-3 py-1 text-end">Valeur</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="bg-[#E5E4E4]">
                                <td class="px-3 py-1">2024</td>
                                <td class="px-3 py-1 text-end">
                                    {{ dividendes?.montant2024 ?? '-' }}
                                </td>
                            </tr>
                            <tr class="bg-[#F3F3F3]">
                                <td class="px-3 py-1">2023</td>
                                <td class="px-3 py-1 text-end">
                                    {{ dividendes?.montant2023 ?? '-' }}
                                </td>
                            </tr>
                            <tr class="bg-[#E5E4E4]">
                                <td class="px-3 py-1">2022</td>
                                <td class="px-3 py-1 text-end">
                                    {{ dividendes?.montant2022 ?? '-' }}
                                </td>
                            </tr>
                            <tr class="bg-[#F3F3F3]">
                                <td class="px-3 py-1">2021</td>
                                <td class="px-3 py-1 text-end">
                                    {{ dividendes?.montant2021 ?? '-' }}
                                </td>
                            </tr>
                            <tr class="bg-[#E5E4E4]">
                                <td class="px-3 py-1">2020</td>
                                <td class="px-3 py-1 text-end">
                                    {{ dividendes?.montant2020 ?? '-' }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <section class="flex flex-col md:gap-4">
                <div class="flex items-center gap-4">
                    <span class="text-3xl font-semibold text-[#0045E6]"
                        >Dernières Actualités
                    </span>
                    <div class="flex-1 border-t-4 border-gray-200"></div>
                </div>
                <div class="grid w-full grid-cols-1 md:grid-cols-2">
                    <div
                        *ngFor="let media of news; index as i"
                        class="border-b border-[#C1C1C1] py-5 last:border-b-0 md:px-5 md:odd:border-r"
                        [ngClass]="
                            news.length % 2 === 0 &&
                            'md:[&:nth-last-child(2)]:border-b-0'
                        "
                    >
                        <a
                            [routerLink]="[
                                '/actualites',
                                media.themeArticle ? 'articles' : 'news',
                                media.nom | convertToSlug,
                                media.id,
                            ]"
                            class="flex w-full items-start gap-6"
                        >
                            <span class="line-clamp-4 flex-1">
                                <span class="font-semibold sm:text-lg">{{
                                    media.nom
                                }}</span
                                ><br />
                                {{ media?.contenu | extractTextFromHtml }}
                            </span>
                            <app-image
                                [imageClass]="
                                    'w-26 h-26 rounded-lg object-cover sm:w-44'
                                "
                                [imageSrc]="cloud_front + media?.image"
                                [showIfNotLoaded]="true"
                            />
                        </a>
                    </div>
                </div>
            </section>
        </div>
        <div class="relative">
            <app-stats-cards class="sticky top-20 hidden md:flex" />
        </div>
    </div>
</div>

<div
    class="fixed inset-0 z-40 flex flex-col items-center overflow-y-scroll bg-white transition-all duration-150 ease-in-out md:hidden"
    [ngClass]="{
        'translate-x-0 translate-y-0': showStats,
        'translate-x-full translate-y-full': !showStats,
    }"
>
    <app-actif-search class="self-stretch p-4" />
    <app-stats-cards class="p-4" />
</div>
<button
    (click)="showStats = !showStats"
    class="fixed bottom-8 right-4 z-49 block h-12 w-16 rounded bg-blue-800 md:hidden"
>
    <mat-icon
        class="text-white"
        [svgIcon]="showStats ? 'feather:x' : 'mat_outline:query_stats'"
        [ngClass]="showStats ? 'icon-size-5' : 'icon-size-10'"
    />
</button>
